import { Button } from './ui/button';
import { ReactComponent as PlusIcon } from '../assets/Plus.svg';
import { ReactComponent as MinusIcon } from '../assets/Minus.svg';

interface MoreButtonProps {
  onExpand: () => void;
  isExpanded: boolean;
  children: React.ReactNode;
}

export const MoreButton = ({
  onExpand,
  isExpanded,
  children,
}: MoreButtonProps) => (
  <Button size="md" variant="response" className="mb-0.5" onClick={onExpand}>
    {isExpanded ? (
      <MinusIcon className="size-5" />
    ) : (
      <PlusIcon className="size-5" />
    )}
    {children}
  </Button>
);
